
import './styles.css';
import { FormikProps } from 'formik';
import { Alert } from '@/shared/ui';
import { Input, IRadioProps, RadioGroup } from '@/shared/ui';
import { rxFillFrequencyOptions } from "@/shared/constants/medication-quantity";
import { useCallback } from 'react';


interface MedicationFrequencyFormValues {
    fillFrequency: number | '';
    quantity: string;
}


interface MedicationFrequencyPageProps {
    formik: FormikProps<MedicationFrequencyFormValues>;
    prescriptionFlowFlag?: boolean;
    rxShowHowOftenFill?: boolean;
}

export const MedicationQuantityFrequency: React.FC<MedicationFrequencyPageProps> = ({ formik, rxShowHowOftenFill = false }) => {
    const handleDaysSupplyChange = useCallback(
        (item: IRadioProps, e: React.MouseEvent<HTMLDivElement>) => {
            const name = e.target.name;
            let additional = {};
            if (name === 'daysSupply') {
                additional = { quantity: null };
            }
            formik.setValues({
                ...formik.values,
                [name]: Number(item.value),
                ...additional
            });
            formik.setErrors({});
        },
        [formik]
    );

    return (
        <div className="flex flex-col gap-[0.625rem]">
            <div className='flex flex-col bg-mint-200 rounded-lg p-[20px] sm:p-[30px] gap-[15px] sm:gap-[20px]'>
                <span className="block font-bold atkinsonHyperlegible text-18 md:text-20 leading-[133%]">Check your medication bottle label for the quantity.</span>
                <div>
                    <Input
                        label={"Quantity (also written as QTY)"}
                        name="quantity"
                        type='text'
                        placeholder="ex. 3"
                        value={formik.values.quantity}
                        required
                        onChange={(e) => {
                            const rawValue = e.target.value;
                            let sanitizedValue = rawValue.replace(/[^0-9]/g, '');
                            sanitizedValue = sanitizedValue.replace(/^0+/, '');
                            if (!sanitizedValue || sanitizedValue === '0') {
                                formik.setFieldValue('quantity', null)
                            } else {
                                formik.setFieldValue('quantity', sanitizedValue)
                            }
                            formik.setErrors({});
                        }}
                        onBlur={formik.handleBlur}
                        error={!!formik.errors.quantity}
                        sx={formik.errors.quantity ? {
                            "&.Mui-disabled": {
                                "& .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "red", // your custom border color
                                },
                            }
                        } : {}}
                        labelClassName={`${formik.errors.quantity ? 'text-red-500' : ''} !text-18 sm:!text-21`}
                        testId="register-form-create-password"
                        className=""
                        enableNaturalEnter
                    />
                    {formik.errors.quantity && formik.touched.quantity && <Alert boldLabel={false} className='mt-[0.625rem]' label={formik.errors.quantity} />}
                </div>
            </div>
            {rxShowHowOftenFill && (
                <div className='flex flex-col bg-mint-200 rounded-lg p-[20px] sm:p-[30px] gap-[15px] sm:gap-[20px]'>
                    <span className="block font-bold atkinsonHyperlegible text-18 md:text-20 leading-[133%]">How often do you usually get this prescription refilled?</span>
                    <div>
                        <RadioGroup
                            controlled
                            optionType="radio"
                            items={rxFillFrequencyOptions}
                            name="fillFrequency"
                            dataTestId="rx-fill-frequency-options"
                            radioGroupClassName="w-full"
                            buttonClassName="select-quantity-radio-button"
                            value={formik.values.fillFrequency}
                            onOptionClick={handleDaysSupplyChange}
                        />
                        {formik.errors.fillFrequency && formik.touched.fillFrequency && <Alert className='mt-[0.625rem]' label={formik.errors.fillFrequency} />}
                    </div>
                </div>
            )}
        </div>
    )
}

export default MedicationQuantityFrequency;